<template>
  <div v-if="msg_ready">
    <transition :name="animations.standard.name" :enter-active-class="animations.standard.enter" :leave-active-class="animations.standard.leave">
      <div class="card">
        <div class="card-header">
          <h4>Aktuelle Meldungen</h4>
        </div>
        <div class="card-body" v-if="!display_error">
          <div class="message-container pointer" v-for="msg in pages[currentPage - 1]" :key="'msg_' + msg.id" @click="showMessageDetail(msg)">
            <div class="message-head">
              <div class="title">
                <h5>{{ msg.title }}</h5>
                <span>{{ transformDate(msg.created_on) }}</span>
              </div>
              <div class="preview_badges">
                <span class="badge badge-primary">{{ ucFirst(msg.context) }}</span>
                <span class="badge badge-info" v-if="msg.priority == 'niedrig'">Information</span>
                <span class="badge badge-success" v-if="msg.priority == 'normal'">Meldung</span>
                <span class="badge badge-warning" v-if="msg.priority == 'hoch'">Wichtig</span>
              </div>
            </div>
          </div>
          <div id="iam-pagination">
            <div
              v-for="(page, index) in pages.length"
              :key="'btn_page_' + index"
              class="pagination-button"
              @click="setCurrentPage(page)"
              :class="{ active: isCurrentPage(page) }"
            >
              {{ page }}
            </div>
          </div>
        </div>
        <div class="card-body" v-if="display_error">
          <h6>Keine Nachrichten gefunden.</h6>
        </div>
      </div>
    </transition>
    <b-modal id="showBoardMessageDetail" @cancel="closeModal" size="lg" ok-only>
      <div class="message-body" v-html="modal_message.body"></div>
      <template slot="modal-header">
        <div class="header-with-date">
          <div class="header-title">
            <h4>{{ modal_message.title }}</h4>
            <span>{{ transformDate(modal_message.created_on) }}</span>
          </div>
          <div class="header-pills preview-badges">
            <span class="badge badge-primary" v-if="modal_message.context">{{ ucFirst(modal_message.context) }}</span>
            <span class="badge badge-info" v-if="modal_message.priority == 'niedrig'">Information</span>
            <span class="badge badge-success" v-if="modal_message.priority == 'normal'">Meldung</span>
            <span class="badge badge-warning" v-if="modal_message.priority == 'hoch'">Wichtig</span>
          </div>
        </div>
      </template>
      <template slot="modal-ok">Schließen</template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KundeBoardMessages",
  data() {
    return {
      loading: true,
      ready: false,
      msg_ready: false,
      display_messages: false,
      modal_message: false,
      display_error: false,
      perPage: 3,
      currentPage: 1,
    };
  },
  watch: {
    allMessages: function() {
      if (this.allMessages.length && this.kuwo.length) this.getBoardMessages();
    },
  },
  computed: {
    ...mapGetters({
      kunde: "auth/kou",
      animations: "app/animations",
      toasts: "app/toasts",
      wohnungen: "app/wohnungen",
      kuwo: "app/kuwo",
      readyState: "app/readyState",
      board: "msg/messages",
      allMessages: "msg/allMessages",
      boardsReady: "msg/boardsReady",
      boardUpdates: "msg/updating",
    }),
    pageCount() {
      const result = Math.ceil(this.display_messages.length / this.perPage);
      return result;
    },
    pages() {
      let runs = 0;
      let result = [];
      let pageArray = [];
      this.display_messages.forEach((msg) => {
        if (runs == this.perPage) {
          runs = 0;
          result.push(pageArray);
          pageArray = [];
          pageArray.push(msg);
        } else {
          pageArray.push(msg);
          runs++;
        }
      });
      result.push(pageArray);
      return result;
    },
  },
  async created() {
    if (!this.readyState.kunde_wohnungen) {
      this.loading = true;
      try {
        await this.$store.dispatch("app/getKundeWohnungen", this.kunde.id);
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      } finally {
        this.loading = false;
      }
    }
    this.getBoardMessages();
  },
  methods: {
    isCurrentPage(page) {
      return page == this.currentPage;
    },
    setCurrentPage(page) {
      this.currentPage = page;
    },
    closeModal() {
      this.$bvModal.hide("showBoardMessageDetail");
      this.modal_message = false;
    },
    showMessageDetail(msg) {
      this.modal_message = msg;
      this.$bvModal.show("showBoardMessageDetail");
    },
    getBoardMessages() {
      if(this.kuwo) {
        const kuBp = this.kuwo.map((kuwo) => {
          return kuwo.haus.haus_bp.id;
        });
        const kuHa = this.kuwo.map((kuwo) => {
          return kuwo.haus.id;
        });
        const kuWo = this.kuwo.map((kuwo) => {
          return kuwo.id;
        });

        const complete = {
          bauprojekt: [...kuBp],
          haus: [...kuHa],
          wohnung: [...kuWo],
          kunde: [this.kunde.id],
        };

        const filterMessages = this.filterMessages(complete);
        const messages = this.loadMessages(filterMessages);
        
        if (messages.length) {
          this.display_messages = messages;
          this.display_messages.sort(this.date_sort);
        } else {
          this.display_error = true;
        }
        this.msg_ready = true;
      }
    },
    filterMessages(targets) {
      let result = [];
      const keys = Object.keys(targets);
      const len = keys.length;

      for (let a = 0; a < len; a++) {
        for (let b = 0; b < targets[keys[a]].length; b++) {
          const res = this.board[keys[a]].filter((m) => m[keys[a] + "_id"] == targets[keys[a]][b]);
          const resLength = res.length;
          if (resLength) {
            for (let c = 0; c < resLength; c++) {
              if (result.find((val) => val.message_id == res[c].message_id) == undefined) result.push({ ...res[c], context: keys[a] });
            }
          }
        }
      }
      return result;
    },
    loadMessages(ids) {
      let result = [];
      const length = ids.length;
      for (let i = 0; i < length; i++) {
        const msg = this.allMessages.find((m) => m.id == ids[i].message_id);
        if (msg !== undefined) result.push({ ...msg, context: ids[i].context });
      }

      return result;
    },
  },
};
</script>

<style>
#iam-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-button {
  padding: 15px;
  color: #004f7d;
  background: white;
  cursor: pointer;
  margin: 3px;
}

.pagination-button:hover,
.pagination-button.active {
  color: white;
  background: #004f7d;
}

.message-container {
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  border: 1px solid #f9f9f9;
  padding: 20px;
  margin-bottom: 10px;
  background: #f9f9f9;
  border-radius: 10px;
}

.message-head {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
}
.header-with-date {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  width: 100%;
}
</style>
